var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReactIcon = function SvgReactIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 46,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#react_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#61DAFB",
    d: "M25.5 27.688a4.457 4.457 0 1 0 0-8.913 4.457 4.457 0 0 0 0 8.913"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#61DAFB",
    strokeWidth: 2.174,
    d: "M25.5 32.362c13.207 0 23.913-4.088 23.913-9.13s-10.706-9.13-23.913-9.13-23.913 4.087-23.913 9.13c0 5.042 10.706 9.13 23.913 9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#61DAFB",
    strokeWidth: 2.174,
    d: "M17.593 27.797C24.196 39.234 33.09 46.462 37.457 43.94s2.554-13.837-4.05-25.275S17.911.002 13.544 2.523c-4.368 2.522-2.555 13.838 4.049 25.275Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#61DAFB",
    strokeWidth: 2.174,
    d: "M17.593 18.667C10.99 30.103 9.177 41.42 13.543 43.94c4.368 2.521 13.26-4.707 19.864-16.144s8.417-22.753 4.05-25.275C33.09.002 24.197 7.23 17.593 18.667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "react_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.989h50v44.486H.5z"
  })))));
};
export default SvgReactIcon;